import React, {Suspense} from 'react';
import type {BlockSpecificData} from '../../types/block';
import {Block, GenericBlock, BlockProps} from './Block';
import {BlogPostPreviewProps} from '../blogPost/BlogPostPreview';

type Props = {
  content: GenericBlock[];
  blockSpecificData?: BlockSpecificData;
  relatedBlogPostsByTag: {[tag: string]: BlogPostPreviewProps['data'][]};
  template: BlockProps['template'];
};

export const Container: React.FC<Props> = props => (
  <>
    {props.content.map((block, index, blocks) => {
      let nextBlockSameType = false;
      const nextBlock = blocks[index + 1];
      if (nextBlock) {
        if (nextBlock.__typename === block.__typename) {
          nextBlockSameType = true;
        }
      }

      let previousBlockSameType = false;
      const previousBlock = blocks[index - 1];
      if (previousBlock) {
        if (previousBlock.__typename === block.__typename) {
          previousBlockSameType = true;
        }
      }
      return (
        <Suspense key={block.id}>
          <Block
            nextBlockSameType={nextBlockSameType}
            previousBlockSameType={previousBlockSameType}
            block={block}
            relatedBlogPostsByTag={props.relatedBlogPostsByTag}
            blockSpecificData={props.blockSpecificData}
            template={props.template}
          />
        </Suspense>
      );
    })}
  </>
);
